"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _coreIcon = _interopRequireDefault(require("@vfuk/core-icon"));
var _coreNumberBadge = _interopRequireDefault(require("@vfuk/core-number-badge"));
var _coreLinkWithIcon = _interopRequireDefault(require("@vfuk/core-link-with-icon"));
var _coreLink = _interopRequireDefault(require("@vfuk/core-link"));
var _coreMatchMedia = require("@vfuk/core-match-media");
var _coreBaseProps = require("@vfuk/core-base-props");
var Styled = _interopRequireWildcard(require("./styles/SideNavigationList.style"));
var _constants = require("../../../../constants");
var _TopNavigationContext = _interopRequireDefault(require("../../../../context/TopNavigationContext"));
var _registerAriaTree = _interopRequireDefault(require("../../../../helpers/registerAriaTree"));
var _SideNavigationCard = _interopRequireDefault(require("../SideNavigationCard"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var SideNavigationList = function SideNavigationList(_ref) {
  var links = _ref.links,
    onClick = _ref.onClick,
    activeLinkId = _ref.activeLinkId,
    backLinkClick = _ref.backLinkClick,
    navLevel = _ref.navLevel,
    dataSelectorPrefix = _ref.dataSelectorPrefix;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useBreakpoints = (0, _coreMatchMedia.useBreakpoints)(),
    sm = _useBreakpoints.sm,
    mdAndAbove = _useBreakpoints.mdAndAbove;
  var _ref2 = (0, _react.useContext)(_TopNavigationContext["default"]),
    animationDuration = _ref2.animationDuration,
    interactionHandler = _ref2.interactionHandler,
    appearance = _ref2.appearance,
    topNavigationTheme = _ref2.topNavigationTheme;
  var handleClick = function handleClick(link, event) {
    var _getDataSelector;
    interactionHandler(event, (_getDataSelector = (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, link.id)) !== null && _getDataSelector !== void 0 ? _getDataSelector : '');
    onClick(link);
  };
  var handleBackClick = function handleBackClick(event) {
    interactionHandler(event, _constants.DataKeys.BackLink);
    backLinkClick();
  };
  var showBackLink = sm && navLevel > 1 || navLevel > 2;
  var _topNavigationTheme$a = topNavigationTheme.appearance[appearance].sideTray.level[navLevel > 1 ? 2 : 1],
    linkWithIconAppearance = _topNavigationTheme$a.linkWithIconAppearance,
    inverseLink = _topNavigationTheme$a.inverseLink,
    linkAppearance = _topNavigationTheme$a.linkAppearance,
    numberBadgeAppearance = _topNavigationTheme$a.numberBadgeAppearance,
    iconAppearance = _topNavigationTheme$a.iconAppearance;
  return /*#__PURE__*/_react["default"].createElement(Styled.LinksWrapper, {
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }, /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, showBackLink && /*#__PURE__*/_react["default"].createElement(Styled.LinkListItem, {
    fullWidth: false
  }, /*#__PURE__*/_react["default"].createElement(_coreLinkWithIcon["default"], {
    text: t('Back'),
    icon: {
      name: 'chevron-left',
      justify: 'left'
    },
    size: 3,
    onClick: handleBackClick,
    appearance: linkWithIconAppearance,
    inverse: inverseLink,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, _constants.DataKeys.BackLink)
  })), links.map(function (link) {
    return /*#__PURE__*/_react["default"].createElement(Styled.LinkListItem, {
      key: link.id,
      fullWidth: true
    }, navLevel === 2 && link.card ? /*#__PURE__*/_react["default"].createElement(_SideNavigationCard["default"], {
      id: link.id,
      appearance: link.card.appearance,
      text: link.text,
      srText: link.srText,
      image: link.card.image,
      href: link.href,
      onClick: link.onClick,
      customRouterProps: link.customRouterProps,
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "".concat(_constants.DataKeys.SideNavigation, "-").concat(link.id)),
      dataAttributes: link.dataAttributes
    }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, mdAndAbove && navLevel > 1 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, link.links ? /*#__PURE__*/_react["default"].createElement(_coreLinkWithIcon["default"], {
      id: link.id,
      text: link.text,
      appearance: linkWithIconAppearance,
      inverse: inverseLink,
      onClick: function onClick(event) {
        return handleClick(link, event);
      },
      customRouterProps: link.customRouterProps,
      href: link.href,
      icon: {
        name: 'chevron-right',
        justify: 'right'
      },
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "".concat(_constants.DataKeys.SideNavigation, "-").concat(link.id)),
      dataAttributes: (0, _registerAriaTree["default"])(link)
    }) : /*#__PURE__*/_react["default"].createElement(_coreLink["default"], {
      id: link.id,
      text: link.text,
      onClick: link.onClick,
      customRouterProps: link.customRouterProps,
      href: link.href,
      appearance: linkAppearance,
      inverse: inverseLink,
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "".concat(_constants.DataKeys.SideNavigation, "-").concat(link.id))
    })) : /*#__PURE__*/_react["default"].createElement(Styled.MenuLink, {
      id: link.id,
      customRouterProps: link.customRouterProps,
      href: link.href,
      onClick: function onClick(event) {
        return handleClick(link, event);
      },
      "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "".concat(_constants.DataKeys.SideNavigation, "-").concat(link.id)),
      dataAttributes: (0, _registerAriaTree["default"])(link)
    }, /*#__PURE__*/_react["default"].createElement(Styled.MenuLinkWrapper, null, /*#__PURE__*/_react["default"].createElement(Styled.MenuLinkText, {
      selected: activeLinkId === link.id,
      animationDuration: animationDuration,
      appearance: appearance,
      topNavigationTheme: topNavigationTheme,
      "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "menu-link-text-".concat(link.id))
    }, link.text), link.numberBadge && /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeWrapper, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
      number: link.numberBadge,
      appearance: numberBadgeAppearance,
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "number-badge-".concat(link.id))
    }))), link.links && /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], {
      name: "chevron-right",
      size: 4,
      appearance: iconAppearance,
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "icon-".concat(link.id))
    }))));
  })));
};
SideNavigationList.displayName = "SideNavigationList";
var _default = SideNavigationList;
exports["default"] = _default;